export default "__VITE_PUBLIC_ASSET__fc525a5c__"